import { useSelector } from 'react-redux'

import usePEQuarters from './usePEQuarters'
import { getAuthUserId } from '../../../../data/auth/authSelectors'
import { RTKQueryHook, RTKQueryResultType } from '../../../../data/baseApi'
import { useGetPlatformEngagementMetricsQuery } from '../data/platformEngagementApi'

export const usePlatformEngagementMetricsData: RTKQueryHook<typeof useGetPlatformEngagementMetricsQuery> = (
  args,
  opts,
) => {
  const userId = useSelector(getAuthUserId)
  const peQuarters = usePEQuarters({ previousYear: args?.previousYear ?? false })

  return useGetPlatformEngagementMetricsQuery(
    {
      providerId: userId,
      data: peQuarters,
    },
    { skip: !peQuarters, ...opts },
  ) as RTKQueryResultType<typeof useGetPlatformEngagementMetricsQuery>
}
